var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagCroatia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 15.9999C32 14.0428 31.6479 12.168 31.0048 10.4347L16 9.73901L0.995188 10.4346C0.352063 12.168 0 14.0428 0 15.9999C0 17.957 0.352063 19.8318 0.995188 21.5651L16 22.2608L31.0048 21.5651C31.6479 19.8318 32 17.957 32 15.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32C22.8794 32 28.7441 27.658 31.0048 21.5652H0.995193C3.25588 27.658 9.12057 32 16 32Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.995193 10.4348H31.0049C28.7441 4.342 22.8794 0 16 0C9.12057 0 3.25588 4.342 0.995193 10.4348Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1735 11.1306H17.3909L17.8547 7.6523L19.7097 6.26099L21.5647 7.6523V10.4349L20.1735 11.1306Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8261 11.1306H14.6087L14.1449 7.6523L12.2898 6.26099L10.4348 7.6523V10.4349L11.8261 11.1306Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8548 11.1304H14.1445V7.65205L15.9997 6.26074L17.8548 7.65205V11.1304Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 10.4348V18.0869C10.4348 19.909 11.3149 21.5294 12.6724 22.5452L13.6464 22.3015L14.8754 23.5379C15.2388 23.6128 15.6149 23.6522 16.0001 23.6522C16.3832 23.6522 16.7574 23.6133 17.1189 23.5391L18.5218 22.371L19.3276 22.5429C20.6845 21.5272 21.5653 19.9085 21.5653 18.0869V10.4348H10.4348Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 10.4348H12.6609V12.6609H10.4348V10.4348Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8869 10.4348H17.113V12.6609H14.8869V10.4348Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3391 10.4348H21.5652V12.6609H19.3391V10.4348Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6604 12.6609H14.8865V14.887H12.6604V12.6609Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1135 12.6609H19.3396V14.887H17.1135V12.6609Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 14.8862H12.6609V17.1123H10.4348V14.8862Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6604 17.1123H14.8865V19.3384H12.6604V17.1123Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8869 14.8862H17.113V17.1123H14.8869V14.8862Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3391 14.8862H21.5652V17.1123H19.3391V14.8862Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1135 17.1123H19.3396V19.3384H17.1135V17.1123Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8869 19.3384H17.113V21.5644H14.8869V19.3384Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6609 19.3386H10.5784C10.7694 20.1661 11.1449 20.9233 11.6598 21.5647H12.6609V19.3386Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3391 21.5647H20.3401C20.8551 20.9233 21.2305 20.1661 21.4215 19.3386H19.3391V21.5647Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6604 21.5647V22.536C13.3078 23.0232 14.0645 23.3725 14.8865 23.5401V21.5647H12.6604Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1135 21.5647V23.5401C17.9356 23.3726 18.6922 23.0232 19.3396 22.536V21.5647H17.1135Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagCroatia);
export default __webpack_public_path__ + "static/media/flag_croatia.35062710a56d301d653a316a0e26c18e.svg";
export { ForwardRef as ReactComponent };